// DEPENDENCIES
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { HubConnectionBuilder } from '@microsoft/signalr';
import moment from 'moment';
// COMPONENTS
import { Link } from 'react-router-dom';
import Picker from 'emoji-picker-react';
import { Modal, Button } from 'react-bootstrap';
import SVG from "react-inlinesvg";
// SERVICES AND HELPERS
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import constants from "../../../../constants/constants";
import * as proposalService from "../../../../services/service/proposalService";

const ProposalReviewerLogsPage = (props) => {
    const { proposalId, auth } = props;

    const [connection, setConnection] = useState(null);
    const [emojiPickerVisible, setEmojiPickerVisible] = useState(false);
    const [chatThread, setChatThread] = useState([]);
    const [isSomeOneTyping, setIsSomeOneTyping] = useState(false);
    const [hasMoreMessages, setHasMoreMessages] = useState(false);
    const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
    const [proposalHistory, setProposalHistory] = useState([]);

    const chatboxRef = useRef();
    const newMessageRef = useRef();
    const latestChatRef = useRef();

    latestChatRef.current = chatThread;

    useEffect(() => {
        const newConnection = new HubConnectionBuilder()
            .withUrl(constants.API_URL + 'hubs/chat', { accessTokenFactory: () => auth.authToken })
            .withAutomaticReconnect()
            .build();

        setConnection(newConnection);
        fetchMessages().then(res => {
            scrollToBottom();
        });
    }, []);

    useEffect(() => {
        if (connection) {
            connection.start()
                .then(result => {
                    connection.on('ProposalMessage/' + proposalId, message => {
                        setChatThread([...latestChatRef.current, message]);
                        scrollToBottom();
                    });

                    connection.on('IsSomeoneTypingOnProposal/' + proposalId, model => {
                        setIsSomeOneTyping((model.isTyping && model.typingId != auth.user.id));
                        scrollToBottom();
                    })
                }).catch(ex => console.log("Connection failed ", ex));
        }

        return () => {
            if (connection)
                connection.stop();
        }
    }, [connection]);

    useEffect(() => {
        if (isHistoryModalOpen) {
            proposalService.GetReviewersHistory(proposalId).then(res => {
                setProposalHistory(res);
            })
        }
    }, [isHistoryModalOpen])

    const fetchMessages = () => proposalService.GetProposalMessages(proposalId, chatThread.length).then(res => {
        setHasMoreMessages(res.hasMore);
        setChatThread(res.proposalMessages);
    }).catch(ex => console.log("Error fetching messages"));

    const ToggleTyping = async (isTyping) => {
        if (connection.connectionStarted) {
            try {
                await connection.send('IsSomeoneTypingOnProposal', {
                    proposalId: parseInt(proposalId),
                    isTyping: isTyping,
                    typingId: auth.user.id
                });
            } catch (e) {
                console.log(e)
            }
        } else {
            alert('Connection could not be established');
        }
    }

    const sendMessage = async (message) => {
        if (message.length > 0) {
            if (connection.connectionStarted) {
                try {
                    await connection.send('SendProposalMessage',
                        {
                            senderId: parseInt(auth.user.id),
                            proposalId: parseInt(proposalId),
                            dateTime: new Date(),
                            message: message
                        }
                    );
                    newMessageRef.current.innerHTML = "";

                } catch (e) {
                    console.log(e)
                }
            } else {
                console.log('Connection could not be established');
            }
        }

    }

    const scrollToBottom = () => {
        setTimeout(() => {
            if (chatboxRef.current)
                chatboxRef.current.scrollTo(0, 99999);
        }, 500)
    }

    const onEmojiClick = (event, emojiObject) => {
        newMessageRef.current.innerHTML += emojiObject.emoji;
    }

    const AvatarComponent = ({ imageUrl, senderId }) => <Link to={"/management/user-profile/personal-information/" + senderId}>
        <div
            className="avatar-box"
            style={{
                backgroundImage: `url(${constants.API_URL + imageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}
        ></div>
    </Link>

    return (
        <>
            <Modal show={isHistoryModalOpen} size="lg" onHide={() => setIsHistoryModalOpen(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Reviewer History</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="tab-content">
                        <div className="table-responsive">
                            <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
                                <thead>
                                    <tr className="text-left text-uppercase">
                                        <th className="pl-7" style={{ minWidth: "250px" }}><span className="text-dark-75">User</span></th>
                                        <th style={{ minWidth: "130px" }}>Assigned Date</th>
                                        <th style={{ minWidth: "100px" }}>Has Reveiwed?</th>
                                        <th style={{ minWidth: "130px" }}>Reveiwed Date Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        proposalHistory.map(x =>
                                            <tr>
                                                <td className="pl-0 py-8">
                                                    <div className="d-flex align-items-center">
                                                        <div className="symbol symbol-50 symbol-light mr-4">
                                                            <span className="symbol-label">
                                                                <div
                                                                    className="h-110 w-110 align-self-end img-block background-image-container"
                                                                    style={{
                                                                        backgroundImage: `url(${x.imageUrl ? (constants.API_URL + x.imageUrl) : ("/media/users/default.jpg")})`,
                                                                        width: '110%',
                                                                        height: '110%'
                                                                    }}
                                                                >
                                                                </div>
                                                            </span>

                                                        </div>
                                                        <div>
                                                            <a href="#" className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{x.fullName}</a>
                                                            <span className="text-muted font-weight-bold d-block">{x.proposalRole}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span style={{ textAlign: 'center' }} className="text-dark-75 font-weight-bold d-block font-size-lg">{x.assignedDate}</span>
                                                </td>
                                                <td>
                                                    <span style={{ textAlign: 'center' }} className="text-dark-75 font-weight-bold d-block font-size-lg">
                                                        <SVG
                                                            className="h-50 align-self-center"
                                                            src={toAbsoluteUrl(x.hasReviewed ? "/media/svg/icons/Navigation/Check.svg" : "/media/svg/icons/Navigation/Close.svg")}
                                                        >
                                                        </SVG>
                                                    </span>
                                                </td>
                                                <td>
                                                    <span style={{ textAlign: 'center' }} className="text-dark-75 font-weight-bold d-block font-size-lg">{x.reviewedDateTime}</span>
                                                </td>
                                            </tr>
                                        )
                                    }

                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setIsHistoryModalOpen(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <div className="card card-custom">
                <div className="card-header py-3">
                    <div className="card-title align-items-start flex-column">
                        <h3 className="card-label font-weight-bolder text-dark">
                            Reviewers Logs
                        </h3>
                        <span className="text-muted font-weight-bold fz-xs mt-1">
                            View & Add Reviewer Logs to this Proposal
                        </span>
                    </div>
                    <div className="card-toolbar">
                        <a
                            onClick={() => setIsHistoryModalOpen(true)}
                            className="btn btn-info"
                        >
                            More Options
                        </a>
                    </div>
                </div>
                <div className="card-body">
                    <div className="chat-platform-container">
                        <div className="chat-box-block-container" ref={chatboxRef}>
                            {
                                hasMoreMessages && <div className="info-strip">
                                    <p>
                                        <a onClick={() => fetchMessages()}>See More</a>
                                    </p>
                                </div>
                            }
                            {
                                chatThread.map((chat, index) =>
                                    <>
                                        {
                                            chat.senderId ?
                                                <div key={index} className={`message-block ${auth.user.id === chat.senderId ? "right" : "left"}`}>
                                                    {
                                                        index + 1 == chatThread.length ?
                                                            <AvatarComponent imageUrl={chat.imageUrl} senderId={chat.senderId} />
                                                            :
                                                            chatThread[index + 1]['senderId'] != chatThread[index]['senderId'] ?
                                                                <AvatarComponent imageUrl={chat.imageUrl} senderId={chat.senderId} /> :
                                                                <div
                                                                    className="avatar-box"
                                                                    style={{
                                                                        background: 'white'
                                                                    }}
                                                                ></div>
                                                    }
                                                    <div className="message-box-container">
                                                        {
                                                            index == 0 ?
                                                                <Link to={"/management/user-profile/personal-information/" + chat.senderId}> <h5>{chat.name}</h5> </Link> :
                                                                chatThread[index - 1]['senderId'] != chatThread[index]['senderId'] &&
                                                                <Link to={"/management/user-profile/personal-information/" + chat.senderId}>
                                                                    <h5>{chat.name}</h5>
                                                                </Link>
                                                        }
                                                        <div className="message-box">
                                                            <p>
                                                                {chat.message}
                                                            </p>
                                                            <div className="time-stamp-container">
                                                                <p>{moment(chat.dateTime).format("ddd, MMM DD hh:mm a")}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> :
                                                <div className="info-strip">
                                                    <p>
                                                        {chat.message}
                                                    </p>
                                                </div>

                                        }
                                    </>
                                )
                            }

                            {
                                isSomeOneTyping && <div className={`message-block left`}>
                                    <div className="typing">
                                        <div className="typing__dot"></div>
                                        <div className="typing__dot"></div>
                                        <div className="typing__dot"></div>
                                    </div>
                                </div>
                            }

                            {
                                emojiPickerVisible &&
                                <div
                                    className="emoji-picker-container"
                                >
                                    <Picker
                                        onEmojiClick={onEmojiClick}
                                        disableAutoFocus={true}
                                    />
                                </div>
                            }
                        </div>
                        <form className="chat-input-block-container">
                            <div className="input-block">
                                <span
                                    onFocus={() => ToggleTyping(true)}
                                    onBlur={() => ToggleTyping(false)}
                                    className="autogrow-textarea"
                                    role="textbox"
                                    contentEditable
                                    ref={newMessageRef}>
                                </span>
                            </div>
                            <div className="actions-block">
                                <button
                                    type="button"
                                    className="btn btn-warning mr-0"
                                    onClick={() => setEmojiPickerVisible(!emojiPickerVisible)}
                                >
                                    <span className="svg-icon svg-icon-lg mr-0">
                                        <i className="far fa-laugh"></i>
                                    </span>
                                </button>

                                <button
                                    onClick={e => {
                                        e.preventDefault();
                                        sendMessage(newMessageRef.current.innerText)
                                    }}
                                    type="submit"
                                    className="btn btn-info mr-0"
                                >
                                    <span className="svg-icon svg-icon-lg mr-0">
                                        <SVG
                                            src={toAbsoluteUrl(
                                                "/media/svg/icons/Communication/Send.svg"
                                            )}
                                        ></SVG>
                                    </span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateToProps, null)(ProposalReviewerLogsPage);